import type ChatContentScrollViewPlatformStyles from './types';

const chatContentScrollViewPlatformStyles: ChatContentScrollViewPlatformStyles = {
    overflow: 'hidden',
};

export default chatContentScrollViewPlatformStyles;
